import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const keywordsService = {
    get,
};

function get(data, page, pageSize) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/analytics/keywords?page=${page}&pageSize=${pageSize}`, requestOptions).then(
        handleResponse,
    );
}
